import type { AuthorizedResourceAccessMap } from './adapter';
import { buildPermissionKey } from './adapter';
import { EMPLOYEE_PORTAL_PERMISSION_RESOURCES } from './definitions';

export const DEV_PERMISSION_BYPASS_STORAGE_KEY =
  'hr-employee.devPermissionBypass';
export const DEV_PERMISSION_BYPASS_HEADER = 'x-dev-permission-bypass';
export type PermissionAccessStatus = 'loading' | 'ready' | 'error';

const isDevelopment = () => process.env.NODE_ENV === 'development';
const canUseStorage = () =>
  typeof window !== 'undefined' && Boolean(window.localStorage);

export const getDevPermissionBypassEnabled = () =>
  canUseStorage() &&
  window.localStorage.getItem(DEV_PERMISSION_BYPASS_STORAGE_KEY) === 'true';

export const setDevPermissionBypassEnabled = (enabled: boolean) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(
    DEV_PERMISSION_BYPASS_STORAGE_KEY,
    enabled ? 'true' : 'false',
  );
};

export const isDevPermissionBypassActive = () =>
  isDevelopment() && getDevPermissionBypassEnabled();

export const buildDevPermissionBypassAccessMap =
  (): AuthorizedResourceAccessMap => {
    if (!isDevPermissionBypassActive()) return {};

    return EMPLOYEE_PORTAL_PERMISSION_RESOURCES.reduce<AuthorizedResourceAccessMap>(
      (access, resource) => {
        access[resource.code] = true;
        resource.actions.forEach((action) => {
          access[buildPermissionKey(resource.code, action.name)] = true;
        });
        return access;
      },
      {},
    );
  };

export const getEffectiveAuthorizedResourceAccess = (
  authorizedResourceAccess: AuthorizedResourceAccessMap | undefined = {},
  _permissionAccessStatus?: PermissionAccessStatus,
) =>
  isDevPermissionBypassActive()
    ? { ...authorizedResourceAccess, ...buildDevPermissionBypassAccessMap() }
    : authorizedResourceAccess;

export const buildDevPermissionBypassHeaders = (): Record<string, string> =>
  isDevPermissionBypassActive()
    ? { [DEV_PERMISSION_BYPASS_HEADER]: 'true' }
    : {};
